(function () {
  const guides = document.querySelectorAll("[data-laptop-size-guide]");
  const LARGEST_SIZE_LABEL = "16-18 inch (Gaming Laptops)";

  if (guides.length === 0) {
    return;
  }

  function selectVariantSize(formId, sizeLabel, guide) {
    const inputs = document.querySelectorAll(`input[form="${formId}"][data-option-position="1"]`);

    for (const input of inputs) {
      const label = document.querySelector(`label[for="${input.id}"]`);
      const labelText = label ? label.textContent.replace(/\s+/g, " ").trim() : "";

      if (!labelText.includes(sizeLabel)) {
        continue;
      }

      input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));
      label?.click();
      guide.closest("x-drawer")?.hide();
      return true;
    }

    return false;
  }

  function openSupportWidget() {
    const trigger = document.querySelector("#chb-root #chb-fab");
    const card = document.querySelector("#chb-root #chb-card");

    if (!trigger) {
      return false;
    }

    if (card && card.classList.contains("show")) {
      return true;
    }

    trigger.click();
    return true;
  }

  function openSupportWidgetWithRetry() {
    if (openSupportWidget()) {
      return;
    }

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;

      if (openSupportWidget() || attempts >= 8) {
        window.clearInterval(timer);
      }
    }, 400);
  }

  guides.forEach((guide) => {
    guide.addEventListener("click", (event) => {
      const sizeButton = event.target.closest("[data-select-size]");
      const largestButton = event.target.closest("[data-select-largest-size]");
      const supportButton = event.target.closest("[data-open-support-ticket]");

      if (supportButton) {
        openSupportWidgetWithRetry();
        return;
      }

      let sizeLabel = null;

      if (sizeButton) {
        sizeLabel = sizeButton.dataset.selectSize;
      } else if (largestButton) {
        sizeLabel = LARGEST_SIZE_LABEL;
      } else {
        return;
      }

      const formId = guide.dataset.formId;

      if (!formId || !sizeLabel) {
        return;
      }

      const didSelect = selectVariantSize(formId, sizeLabel, guide);

      if (!didSelect) {
        window.setTimeout(() => {
          const optionsBlock = document.querySelector('[data-block-type="variant-picker"], .product-info__variant-picker');
          optionsBlock?.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 80);
      }
    });
  });
})();
